import React from 'react'

import SingleInput from '../Fields/SingleInput'
import Signature from '../Fields/Signature'

import classes from './layout.css'

const ModuleFive = (props) => {
	return (
		<div>
			<div className={classes.Section}>
				<SingleInput
					name={"patientSignDate"}
					inputType={"date"}
					controlFunc={props.addToForm}
					value={props.consentForm.patientSignDate}
				/>
				<label>Patient's (or Legal Guardian's) Signature:</label>
				<Signature 
					controlFunc={props.addToForm}
					name={"patientSignature"}
					value={props.consentForm.patientSignature}
				/>
			</div>

			<div className={classes.Section}>
				<SingleInput
					name={"doctorSignDate"}
					inputType={"date"}
					controlFunc={props.addToForm}
					value={props.consentForm.doctorSignDate}

				/>
				<label>Doctor's Signature:</label>
				<Signature 
					controlFunc={props.addToForm}
					name={"doctorSignature"}
					value={props.consentForm.doctorSignature}
				/>
			</div>

			<div className={classes.Section}>
				<SingleInput
					name={"witnessSignDate"}
					inputType={"date"}
					controlFunc={props.addToForm}
					value={props.consentForm.witnessSignDate}
				/>
				<label>Witness' Signature:</label>
				<Signature 
					controlFunc={props.addToForm}
					name={"witnessSignature"}
					value={props.consentForm.witnessSignature}
				/>
			</div>
		</div>
	)
}

export default ModuleFive


// WEBPACK FOOTER //
// ./src/components/Modules/5.js